import { api, API_BASE } from './api';
import { tokenStore } from './tokenStore';

function buildQs(params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === '') return;
    qs.append(k, String(v));
  });
  return qs.toString();
}

/** Trigger a file download from an authenticated API endpoint. */
async function downloadXlsx(path, params, filename) {
  const qs  = buildQs(params);
  const url = `${API_BASE}${path}${qs ? `?${qs}` : ''}`;
  const token = tokenStore.getAccessToken();
  const res = await fetch(url, {
    method: 'GET',
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}) },
  });
  if (!res.ok) throw new Error(`Export failed: HTTP ${res.status}`);
  const blob   = await res.blob();
  const objUrl = URL.createObjectURL(blob);
  const a      = document.createElement('a');
  a.href       = objUrl;
  a.download   = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(objUrl);
}

export const reportsApi = {
  // Trial Balance
  getTrialBalance: (params) => {
    const q = buildQs(params);
    return api.get(`/reports/trial-balance${q ? `?${q}` : ''}`);
  },
  exportTrialBalance: (params, filename = 'trial-balance.xlsx') =>
    downloadXlsx('/reports/trial-balance/export', params, filename),

  // YTD
  getYtd: (params) => {
    const q = buildQs(params);
    return api.get(`/reports/ytd${q ? `?${q}` : ''}`);
  },
  exportYtd: (params, filename = 'ytd-report.xlsx') =>
    downloadXlsx('/reports/ytd/export', params, filename),

  // P&L
  getPnl: (params) => {
    const q = buildQs(params);
    return api.get(`/reports/pnl${q ? `?${q}` : ''}`);
  },
  exportPnl: (params, filename = 'pnl-report.xlsx') =>
    downloadXlsx('/reports/pnl/export', params, filename),

  // Balance Sheet
  getBalanceSheet: (params) => {
    const q = buildQs(params);
    return api.get(`/reports/balance-sheet${q ? `?${q}` : ''}`);
  },
  exportBalanceSheet: (params, filename = 'balance-sheet.xlsx') =>
    downloadXlsx('/reports/balance-sheet/export', params, filename),

  // Outstanding Vouchers
  getOutstandingVouchers: (params) => {
    const q = buildQs(params);
    return api.get(`/reports/outstanding-vouchers${q ? `?${q}` : ''}`);
  },
  exportOutstandingVouchers: (params, filename = 'outstanding-vouchers.xlsx') =>
    downloadXlsx('/reports/outstanding-vouchers/export', params, filename),

  // Audit Log
  getAuditLog: (params) => {
    const q = buildQs(params);
    return api.get(`/reports/audit-log${q ? `?${q}` : ''}`);
  },
};
